/**
 * Offer list layout: base design 1280×832.
 * Column widths scale with viewport; no hardcoded breakpoints.
 */

/** Viewport width for base design (1280×832). Above this, offer name column flexes to fill space. */
export const baseViewportWidth = 1280;
export const baseOfferNameColumnWidthPx = 192;
const offerNameColumnMinPx = 120;
const offerNameColumnMaxPx = 320;

const ratio = baseOfferNameColumnWidthPx / baseViewportWidth;

export function getOfferNameColumnWidthPx(viewportWidth: number): number {
  const width = viewportWidth * ratio;
  return Math.round(
    Math.max(offerNameColumnMinPx, Math.min(offerNameColumnMaxPx, width))
  );
}

export const defaultOfferNameColumnWidthPx = baseOfferNameColumnWidthPx;

/** Min space below action menu button before opening upward (px). */
export const minSpaceBelowForMenu = 70;

/** Max characters for "Imię i nazwisko" before truncation with "...". */
export const offerNameMaxLength = 100;
